// extracted by mini-css-extract-plugin
module.exports = {"image":"image_image__25-A-","fadein":"image_fadein__29g6J","masked":"image_masked__1j4B-","placeholder":"image_placeholder__3yLSk"};